import { SOCIAL_STARTER_SOURCE_LOCATION } from '#src/app/shared/constants';

/**
 * The draft/angle metadata's `source_location` (page data) wins over any URL `source_location` —
 * it's known for the page's own draft, immune to the URL-param loss modes (Google-return, raw
 * links, retyped URLs) that made the URL param an unreliable source of truth. Falls back to the
 * URL param, then to `social`. Passing the raw code through (rather than collapsing it to an
 * ambassador/not-ambassador boolean first) keeps this working for any future source_location code
 * without changes here.
 */
export function resolveSocialSourceLocation(
	metadataSourceLocation: string | null | undefined,
	urlSourceLocation: string | null | undefined,
): string {
	// `||`, not `??` — a present-but-blank `?source_location=` parses to `''`, which should fall
	// back the same as a missing param, not forward as an empty attribution value.
	return metadataSourceLocation || urlSourceLocation || SOCIAL_STARTER_SOURCE_LOCATION;
}

/**
 * Appends `source_location` to SAP navigation params so SAPv2 tracking and publish
 * attribution carry through.
 */
export function appendSourceLocationToSapParams(
	params: URLSearchParams,
	metadataSourceLocation: string | null | undefined,
	urlSourceLocation: string | null | undefined,
): void {
	params.set('source_location', resolveSocialSourceLocation(metadataSourceLocation, urlSourceLocation));
}
